import type { SsoBrand } from '@utils/oidc-providers.utils'

// Enabled brands render a button here; each resolves via useSsoRoute
// (remembered route → HRD_BRAND_PROVIDERS[brand] → email step). Enabling
// google = add it here AND add a `google=<provider>` entry to
// HRD_BRAND_PROVIDERS in the deploy env.
export const SSO_BRANDS: readonly SsoBrand[] = ['microsoft']
